module.exports = __webpack_public_path__ + "static/tuffy-banner-800x500-0facadb41ed332ae40fac75b0882aa3d.gif";